import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useIncome } from "../../contexts/IncomeContext";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../design/description-list";
import { Heading, Subheading } from "../../design/heading";
import { Divider } from "../../design/divider";
import DeleteIncomeButton from "./components/DeleteIncomeButton";
import LoadingView from "../../components/LoadingView";
import IncomeFilesList from "./components/Files/IncomeFilesList";
import ErrorView from "../../components/ErrorView";
import Breadcrumbs from "../../components/Breadcrumbs";

const IncomeDetailPage: React.FC = () => {
  const { incomeId } = useParams<{ incomeId: string }>();
  const { income, setSelectedIncome, error, loading } = useIncome();

  useEffect(() => {
    if (incomeId) {
      setSelectedIncome(incomeId);
    }
  }, [incomeId]);

  if (loading.details) {
    return <LoadingView />;
  }

  if (error.details) {
    return <ErrorView error={error.details} />;
  }

  if (!income) {
    return <ErrorView error={new Error("Financial Item not found")} />;
  }

  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Property Division", href: "/property-division" },
          {
            label: income.name,
            href: `/financial-item/${income._id}`,
          },
        ]}
      />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex flex-col w-full gap-6">
          <div className="mb-6">
            <div className="flex items-center justify-between">
              <Heading>{income.name}</Heading>
              <div className="flex gap-2">
                <DeleteIncomeButton incomeId={income._id} />
              </div>
            </div>
          </div>
          <Divider className="mt-2" />
          <DescriptionList>
            <DescriptionTerm>Type</DescriptionTerm>
            <DescriptionDetails>{income.type}</DescriptionDetails>
            <DescriptionTerm>Amount</DescriptionTerm>
            <DescriptionDetails>
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(income.amount)}
            </DescriptionDetails>
          </DescriptionList>
          <Subheading>Supporting Files</Subheading>
          <IncomeFilesList incomeId={income._id} />
        </div>
      </div>
    </div>
  );
};

export default IncomeDetailPage;
